import {FC} from 'react'
import {ExtraAction} from '../types'
import Action from './Action'
import MoreActions from './MoreActions'

const ExtraActions: FC<{actions: ExtraAction[]; maxExtraActions?: number}> = ({
  actions,
  maxExtraActions,
}) => {
  const renderActions = []
  const moreActions = []
  for (let i = 0; i < actions.length; i++) {
    const action = actions[i]

    if (action?.hide) continue

    if ((maxExtraActions && i < maxExtraActions) || !maxExtraActions) {
      renderActions.push(<Action action={action} key={i} />)
    } else {
      moreActions.push(action)
    }
  }
  return (
    <>
      {renderActions}
      {moreActions.length > 0 && <MoreActions actions={moreActions} />}
    </>
  )
}

export default ExtraActions
